import React from "react";

export default function Marquee({ items }) {
  const list = [...items, ...items];
  return (
    <div className="w-full overflow-hidden border-y border-brand-line bg-brand-green-dark py-6" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {list.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-display text-2xl md:text-3xl italic text-brand-cream">
            {item}
            <span className="text-brand-gold not-italic text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
